import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { removeUniversalPortals } from 'react-portal-universal';
import PortalsRenderer from '../PortalsRenderer';
import canUseDOM from '../../util/canUseDOM';

class ContentRenderer extends React.Component {
  constructor() {
    super();
    this.canUseDOM = canUseDOM();
    this.state = {
      renderHtml: !this.canUseDOM,
      renderPortals: false
    };
  }

  componentDidMount() {
    this.observer = new MutationObserver(this.renderPortals);
    this.observer.observe(this.container, { childList: true });
    // In client-side, wait for the MutationObserver to be created to render the html
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState(
      { renderHtml: true },
      () => { this.props.afterRender(this.container); }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.html !== nextProps.html) {
      this.setState({ renderPortals: false });
    }
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  renderPortals = () => {
    // Remove portals content server-side rendered so we can
    // render the React components inside the container (client-side) and prevent duplication
    removeUniversalPortals();
    this.setState({ renderPortals: true });
  }

  render() {
    const { html, meta } = this.props;
    const shouldRenderPortalsClient = this.canUseDOM && this.state.renderPortals;
    const shouldRenderPortalsServer = !this.canUseDOM;
    const shouldRenderPortals = shouldRenderPortalsClient || shouldRenderPortalsServer;

    // Only add the dangerouslySetInnerHTML prop to the container
    // after creating the MutationObserver so we can observe the DOM changes
    const renderHtmlProp = this.state.renderHtml ?
      { dangerouslySetInnerHTML: { __html: html } } : {};

    return (
      <Fragment>
        <div
          ref={(e) => { this.container = e; }}
          {...renderHtmlProp}
        />
        {shouldRenderPortals && (
          <PortalsRenderer portals={meta.portals} meta={meta} />
        )}
      </Fragment>
    );
  }
}

ContentRenderer.propTypes = {
  html: PropTypes.node.isRequired,
  meta: PropTypes.object,
  afterRender: PropTypes.func
};

ContentRenderer.defaultProps = {
  meta: {},
  afterRender: () => {}
};

export default ContentRenderer;
